<template>
  <div class="main">
    <van-nav-bar left-text="可用产品" left-arrow fixed @click-left="onClickLeft">
    </van-nav-bar>
    <div class="head">商家优惠：以下商品可使用满{{ useThreshold }}可享</div>
    <div class="content-father">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <template>
          <div class="content" v-for="(item, i) in cardsList" :key="i">
            <van-row class="content-row" gutter="10">
              <van-col>
                <img
                  v-if="item.mainPictureUrl"
                  class="content-img"
                  :src="item.mainPictureUrl"
                  alt=""
                />
                <img
                  v-else
                  class="content-img"
                  src="@/assets/images/dangao.png"
                  alt=""
                />
              </van-col>
              <van-col span="17">
                <div class="content-title">
                  {{ item.title }}
                </div>
                <div class="content-price">
                  ￥{{ item.minPrice }}
                  <img
                    @click="onClcikCart(item, i)"
                    class="cart"
                    src="@/assets/images/free/shopCart.png"
                    alt=""
                  />
                </div>
              </van-col>
            </van-row>
            <div class="van-hairline--bottom"></div>
          </div>
        </template>
      </van-list>
    </div>

    <div class="bar-bottom">
      <div class="bar-content">
        <div class="bar-price">
          <span class="total">小计:</span>
          <span class="total-num"> ￥{{ cartMoney.toFixed(2) }}</span>
        </div>
        <div v-if="moneyTotal" class="bar-text">
          点击产品对应购物车选购产品参与优惠吧！
        </div>
        <div v-else class="bar-text">
          <div v-if="cartMoney>=preferentialContent">满足优惠条件，下单用券立减￥{{ preferentialContent }}</div>
          <div v-else>再买{{(preferentialContent-cartMoney).toFixed(2)}}元，下单用券立减￥{{ preferentialContent }}</div>
        </div>
      </div>
      <div @click="skipCart" class="skip-cart">去购物车</div>
    </div>
    <van-popup
      v-model="show"
      round
      closeable
      close-icon="close"
      position="bottom"
    >
      <div class="popup-wrapper">
        <div class="popupcontent">
          <div class="cart-head">
            <van-row type="flex">
              <van-col>
                <img
                  v-if="itemDetail.mainPictureUrl"
                  :src="itemDetail.mainPictureUrl"
                />
              </van-col>
              <van-col>
                <div class="cart-current">
                  <span class="cart-discounted">折后价</span>
                  <span class="cart-original">￥{{ minPriceNum }}</span>
                </div>
                <div class="cart_price">
                  <span>原价</span>
                  <span>￥{{ itemDetail.price }}</span>
                  <span>{{ itemDetail.discount }}折</span>
                </div>
                <div class="cart_price" v-if="stockShow">
                  <span>库存:{{ stockNum }}</span>
                </div>
              </van-col>
            </van-row>
          </div>
          <div
            class="radios-sku"
            v-for="(ProductItem, n) in simulatedDATA.specifications"
            :key="n"
          >
            <p class="radio-title">{{ ProductItem.name }}</p>
            <van-radio-group
              v-for="(items, i) in ProductItem.item"
              :key="i"
              v-model="getRadios[n]"
              direction="horizontal"
              @change="radioChange"
            >
              <van-radio
                checked-color="#ff3300"
                class="radio-name"
                :name="items.name"
                shape="square"
                >{{ items.name }}</van-radio
              >
            </van-radio-group>
          </div>
        </div>
        <div class="title">服务方式</div>
        <van-radio-group
          v-model="radio"
          @change="handleDelivery"
          class="method"
          direction="horizontal"
        >
          <van-radio
            v-for="(item, i) in delivery"
            :key="i"
            :name="item"
            checked-color="#f2270c"
            icon-size="17px"
            >{{ item | deliveryChange }}</van-radio
          >
        </van-radio-group>

        <van-button
          class="btn-confirm"
          type="primary"
          color="#f2270c"
          block
          round
          @click="handleConfirm"
          >确认</van-button
        >
      </div>
    </van-popup>
  </div>
</template>

<script>
import { addCarts } from '@/api/productsDetaile'
import { PRODUCT_ENQUIRY, PLATFORM_TYPE } from '@/config/platformtype'
import { ProductCardsUseList } from '@/api/productCards'
import { productSku } from '@/api/productsDetaile'
import { Toast } from 'vant'
export default {
  filters: {
    deliveryChange(val) {
      switch (val) {
        case 0:
          return '到店自提'
        case 1:
          return '快递'
        case 2:
          return '同城配送'
      }
    },
  },
  data() {
    return {
      getRadios: [],
      stockNum: 100,
      stockShow: false,
      minPriceNum: '',
      itemDetail: {},
      simulatedDATA: {
        difference: [
          {
            id: '',
            price: '',
            stock: '', // 库存
            difference: '', // 此规格的属性键值
          },
          {
            id: '',
            price: '',
            stock: '',
            difference: '',
          },
        ],
        specifications: [
          {
            name: '',
            item: [
              {
                name: '',
              },
              {
                name: '',
              },
            ],
          },
          {
            name: '',
            item: [
              {
                name: '',
              },
              {
                name: '',
              },
              {
                name: '',
              },
            ],
          },
        ],
      },
      specificationsArray: [],
      useThreshold: 0,
      preferentialContent: '',
      cartMoney: 0.0,
      moneyTotal: true,
      goodsSkuId: Number,
      storeNames: '',
      list: [],
      cardsList: [],
      loading: false,
      finished: false,
      storeId: Number,
      query: {
        current: 1,
        size: 10,
        couponId: '',
        platform: PRODUCT_ENQUIRY,
      },
      delivery: [],
      show: false,
      showPicker: false,
      storeSelfMentionId: 0,
      radio: '',
    }
  },
  components: {},
  created() {
    this.query.couponId = this.$route.query.couponId
    this.preferentialContent = this.$route.query.preferentialContent
    this.useThreshold = this.$route.query.useThreshold
  },
  mounted() {},
  methods: {
    radioChange() {
      this.simulatedDATA.difference.forEach((val, index) => {
        const valArr = val.difference.split(',')
        if (this.simulatedDATA.specifications.length === 1) {
          const retun = valArr.indexOf(this.getRadios[0]) !== -1
          this.radioStatus = retun
        } else if (this.simulatedDATA.specifications.length === 2) {
          const retun =
            valArr.indexOf(this.getRadios[0]) !== -1 &&
            valArr.indexOf(this.getRadios[1]) !== -1
          this.radioStatus = retun
        }
        if (this.radioStatus) {
          this.skuIdTrue = true
          this.goodsSkuId = val.id
          console.log('this.goodsSkuId', this.goodsSkuId)
          this.minPriceNum = val.price
          console.log('this.minPriceNum', val.price)
          this.stockShow = true
          this.stockNum = val.stock
        }
      })
    },
    skipCart() {
      if (this.inApp) {
        // app环境显示传参控制返回按钮显示隐藏
        const showbtn = 0
        this.$router.push({
          path: '/mall/cart',
          query: { displaybtn: showbtn },
        })
      } else {
        this.$router.push({
          path: '/mall/cart',
        })
      }
    },
    onClcikCart(item, elIndex) {
      this.itemDetail = item
      this.show = !this.show
      var taskall = []
      const params = {
        platformType: PLATFORM_TYPE,
        productId: item.id,
      }
      const task = new Promise((resolve, reject) => {
        productSku(params).then((res) => {
          if (res.data.code === 200) {
            this.skusList = res.data.data
            // 当没有规格选择时，默认直接拿id
            if (this.skusList[0].length === 0) {
              this.goodsSkuId = this.skusList[0].id
              this.stockNum = this.skusList[0].stock
              return
            }
            // 规格去重分组
            var mapper = {}
            var group = {}
            this.skusList.forEach((r, i) => {
              r.specifications.forEach((rr, ii) => {
                if (!group.hasOwnProperty(rr.productAttributeId)) {
                  group[rr.productAttributeId] = []
                  mapper[rr.productAttributeId] =
                    's' + Object.keys(group).length
                }
                try {
                  group[rr.productAttributeId].forEach((rrr, iii) => {
                    if (rrr.val === rr.val) throw new Error()
                  })
                  group[rr.productAttributeId].push(rr)
                } catch (e) {}
              })
            })
            // tree
            var tree = []
            Object.keys(group).forEach((r, i) => {
              const item = group[r]
              var treeItem = {
                name: item[0].productAttributeName,
                item: [],
              }
              item.forEach((rr, ii) => {
                treeItem['item'].push({
                  name: rr.val,
                })
              })
              tree.push(treeItem)
            })
            // list
            var list = []
            this.skusList.forEach((r, i) => {
              const listItem = {}
              listItem.id = r.id
              listItem.price = r.platformPrice
              listItem.stock = r.stock
              listItem.amount = r.amount
              listItem.difference = ''
              r.specifications.forEach((rr, ii) => {
                listItem.difference = listItem.difference + rr.val + ','
              })

              listItem.difference = listItem.difference.substring(
                0,
                listItem.difference.length - 1
              )

              list.push(listItem)
            })
            this.simulatedDATA.specifications = tree
            this.simulatedDATA.difference = list
            const differenceArray = []
            this.simulatedDATA.difference.forEach((e) => {
              differenceArray.push(e.amount)
            })
            // 默认选择规格
            if (this.simulatedDATA.difference[0].difference) {
              this.getRadios[0] = this.simulatedDATA.difference[0].difference
              this.goodsSkuId = this.simulatedDATA.difference[0].id
              this.stockNum = this.simulatedDATA.difference[0].stock
              this.minPriceNum = this.simulatedDATA.difference[0].price
              this.stockShow = true

              const differenceList = this.simulatedDATA.difference[0].difference.split(
                ','
              )
              if (differenceList.length > 1) {
                this.getRadios[0] = differenceList[0]
                this.getRadios[1] = differenceList[1]
                this.stockNum = this.simulatedDATA.difference[0].stock
                this.stockShow = true
              }
            }
            // 当没有规格选择时，默认直接拿id
            if (this.skusList[0].specifications.length === 0) {
              console.log('this.skusList[0]',this.skusList[0]);
              this.goodsSkuId = this.skusList[0].id
              this.stockNum = this.skusList[0].stock
              this.minPriceNum = this.skusList[0].platformPrice
            }
          }
        })
      })

      this.delivery = item.deliveryMethodArry
      this.radio = item.deliveryMethodArry[0]
      this.storeNames = item.salesStoreIds
      this.storeSelfMentionId = this.storeNames.split(',')[0]
      this.storeId = item.storeIds.split(',')[0]
      taskall.push(task)
      Promise.all(taskall).then((success) => {
        this.goodsSkuId = item.currentSkuId
      })
    },
    onLoad() {
      ProductCardsUseList(this.query).then((res) => {
        if (res.data.code === 200) {
          const productList = res.data.data.records
          productList.forEach((el, elIndex) => {
            // 变成number类型
            el.deliveryMethodArry = el.deliveryMethod.split(',')
            el.deliveryMethodArry = el.deliveryMethodArry.map(Number)
          })
          this.cardsList = this.cardsList.concat(productList)
          this.totalCount = res.data.data.total
          this.query.current++
          // 加载状态结束
          this.loading = false
          // 数据全部加载完成
          if (this.cardsList.length >= this.totalCount) {
            this.finished = true
          }
        }
      })
    },

    handleDelivery(item) {
      if (item === 0) {
        // 如果自提门店只有一个，就默认选择不必让用户选择
        if (this.storeNames.split(',').length === 1) {
          this.storeSelfMentionId = this.storeNames.split(',')[0]
        } else {
          this.storeSelfMentionId = this.storeNames.split(',')[0]
        }
      }
    },
    handleConfirm() {
      const query = {
        storeSelfMentionId: this.storeSelfMentionId,
        storeId: this.storeId,
        quantity: 1,
        productSkuId: this.goodsSkuId,
        deliveryMethod: this.radio,
      }
      if (this.radio !== 0) {
        delete query.storeSelfMentionId
      }
      const toast = this.$toast.loading({
        message: '商品添加中...',
        forbidClick: true,
      })
      addCarts(query)
        .then((res) => {
          if (res.data.code === 200) {
            toast.clear()
            this.moneyTotal = false
            this.cartMoney = this.cartMoney + this.minPriceNum
          }
        })
        .catch((err) => {
          Toast('添加失败，请重试')
          console.log('err.msg', err.msg)
        })
      this.show = !this.show
    },
    onClickLeft() {
      this.$callApp('Android', 'GoBackAppMethod', '')
      this.$callApp('iOS', 'GoBackAppMethod', '')
    },
    onClickServiceType(val) {
      this.show = !this.show
      this.delivery = val.deliveryMethodArry
      this.radio = val.deliveryMethodArry[0]
      this.storeNames = val.salesStoreIds
      this.storeSelfMentionId = this.storeNames.split(',')[0]
    },
  },
}
</script>

<style scoped lang="less">
/deep/.van-nav-bar__text {
  color: black;
  font-size: 16px;
}

/deep/.van-nav-bar .van-icon {
  color: black;
  font-size: 16px;
}
.content-father {
  padding-bottom: 60px;
}
.main {
  min-height: 100vh;
  background-color: #eee;
  .head {
    padding-top: 46px;
    margin: 15px 20px 15px;
    font-size: 14px;
    color: #666666;
  }
  .content {
    border-radius: 5px;
    background-color: #fff;
    margin: 0 10px;
    .content-row {
      padding: 20px 10px 0;
      .content-img {
        border-radius: 5px;
        width: 80px;
        height: 80px;
      }
      .content-title {
        font-size: 12px;
        color: #121212;
      }
      .content-price {
        color: #f44d4d;
        font-size: 14px;
        padding: 20px 0 10px 0;
        position: relative;
        .cart {
          position: absolute;
          right: 0;
          width: 25px;
          height: 25px;
        }
      }
    }
  }
  .bar-bottom {
    width: 375px;
    height: 49px;
    position: fixed;
    bottom: 0;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    .skip-cart {
      color: #fff;
      background-color: #f44d4d;
      font-size: 20px;
      text-align: center;
      line-height: 49px;
      padding: 0 7px;
    }
    .bar-content {
      padding-left: 10px;
    }
    .bar-price {
      font-size: 16px;
      padding-top: 5px;
      .total {
        color: #121212;
      }
      .total-num {
        color: #f44d4d;
      }
    }
    .bar-text {
      font-size: 11px;
      color: #666;
    }
  }
}
.popup-wrapper {
  padding: 18px 0 18px 18px;
  .title {
    margin-top: 36px;
    margin-bottom: 10px;
    color: #262626;
    height: 31px;
    line-height: 31px;
    font-weight: 700;
    font-size: 13px;
  }

  .method {
    margin-bottom: 50px;
  }

  .btn-confirm {
    position: fixed;
    bottom: 6px;
    width: 339px;
    height: 38px;
  }
  .radios-sku {
    .radio-title {
      font-size: 16px;
      text-align: left;
      margin: 10px 0 5px;
    }
    /deep/.radio-name {
      padding: 4px 0;
      font-size: 14px;
    }
    /deep/.van-radio__icon {
      font-size: 15px;
    }
  }
  .cart-head {
    img {
      margin-right: 10px;
      width: 100px;
      height: 100px;
      border-radius: 5px;
    }
    //折后价
    .cart-current {
      padding-top: 11.5px;
      .cart-discounted {
        width: 56px;
        height: 21px;
        line-height: 21px;
        display: inline-block;
        padding: 2.5px;
        color: white;
        font-size: 15px;
        text-align: center;
        background: @discount-price;
        border-radius: 10.5px;
      }
      .cart-original {
        padding-left: 7.5px;
        vertical-align: middle;
        font-size: 25px;
        font-weight: 400;
      }
    }
    //原价
    .cart_price {
      color: #969799;
      padding-top: 9px;
      text-align: left;
      span {
        font-size: 14px;
        padding: 0 3.5px 0 3.5px;
      }
      span:nth-of-type(2) {
        text-decoration: line-through;
      }
    }
  }
}
</style>
